export class PepMatchResponse {
    suggestionList: Array<PepMatchRecord>;
    date: string;
}

export class PepMatchRecord {
    pepEntity: PepEntity;
    relationEntityId: number;
    matchResolution: number;
    falseMatchReason: number;
    comments: string;
    payloadJson?: string;
}

export class PepEntity {
    id: number;
    startDate: Date;
    endDate: Date;
    description: string;
    personId: number;
    lastName: string;
    firstName: string;
    country: string;
    designation: string;
    globalName: string;
    source: string;
}

export enum PEPMatchResolution {
    PROBABLE = <any>'PROBABLE',
    TRUE = <any>'TRUE',
    FALSE = <any>'FALSE',
}



// WEBPACK FOOTER //
// ./src/app/entities/monitoring/actual/pep-match.model.ts